import React, { useState } from 'react';
import './Product_Description.css';
import { useParams, useNavigate } from "react-router-dom";  // Added useNavigate
import All_products from '../../common-components/all-products/All_products';
// import Increment_Decrement_Btn from '../../common/common_btn/Increment_Decrement_Btn/Increment_Decrement_Btn'
import { Button } from 'react-bootstrap';
import { faBasketShopping, faShareNodes, faSortDown, faStar, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Product_Specification from './Product_Specification/Product_Specification';
import { Link } from 'react-router-dom';
// import Confirm_delivery_add_offcanvas from '../../common/offcanvas/confirm-delivery-add-offcanvas/Confirm_delivery_add_offcanvas'
import Form_component from '../../contact_us/contact_form/Form_component';

const Product_Description = ({ scrollToEnquire }) => {
  const { id } = useParams();
  const product = All_products.find((p) => p.id === parseInt(id));
  const navigate = useNavigate();  // Initialize navigate

  const [makeItComboModalShow, setMakeItComboModalShow] = useState(false);
  const [addDipsModalShow, setAddDipsModalShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addCartBTNShow, setaddCartBTNShow] = useState(false);
  const [showGoToCartModal, setshowGoToCartModal] = useState(false);
  const [show_Select_Product_By_Weight_Modal, set_show_Select_Product_By_Weight_Modal] = useState(false);
  const [disableSelect, setDisableSelect] = useState(false);

  const products = [
    {
      product_name: "Add Bacon Slices",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img1.png",
    },
    {
      product_name: "Add Cheese",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img2.png",
    },
    {
      product_name: "Add Melted Cheese",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img2.png",
    },
  ];

  const [addoffcanvas, setAddoffcanvas] = useState(false);



  return (
    <div className="Product_Description">
      <div className="top_heading">
        <div className="heading_div">
          <p className="heading">{product.title}</p>
        </div>
      </div>

      <div className="description_container row">
        <div className='Product_Description_Text'>
          <p className='heading'>{product.subtitleOptional ? product?.subtitleOptional : ""}</p>
          <p className='heading'>{product.subtitle}</p>
          <div className='text_holder'>
            <p>{product.description}</p>
          </div>
        </div>

        <div className="">
          <Product_Specification />
        </div>

        <div className="footer_btn_holder ">
          <div className='buynowdiv'>
            <button
              className='buynowbtn'
              type='button'
              onClick={scrollToEnquire}
            >
              Enquire Now
            </button>
          </div>
        </div>
      </div>

      {/* <Confirm_delivery_add_offcanvas
        show={addoffcanvas}
        onHide={() => setAddoffcanvas(false)}
      /> */}
    </div>
  );
};

export default Product_Description;
